export default __webpack_public_path__ + "static/media/The Enduring Hate.9bed57f9.jpg";